import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Chip, Box, OutlinedInput } from "@mui/material";

type Props = {
  label: string;
  value: string; // comma-separated string
  onChange: (val: string) => void;
  options: string[];
  disabled?: boolean;
};

export function SalesLevelMultiSelectField({ label, value, onChange, options, disabled }: Props) {
  const selected = value ? value.split(",").map(s => s.trim()).filter(Boolean) : [];

  return (
    <FormControl fullWidth margin="normal">
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={selected}
        onChange={e => {
          const vals = typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value;
          onChange(vals.join(","));
        }}
        input={<OutlinedInput label={label} />}
        renderValue={selectedVals => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {(selectedVals as string[]).map((val, idx) => (
              <Chip key={idx} label={val} size="small" />
            ))}
          </Box>
        )}
        disabled={disabled}
      >
        {options.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}